import { useEffect } from "react";
import Hero from "@/components/Hero";
import QuickBookingSection from "@/components/QuickBookingSection";
import Trust from "@/components/Trust";
import VehicleClasses from "@/components/VehicleClasses";
import PricingSection from "@/components/PricingSection";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import CoverageSection from "@/components/CoverageSection";
import CorporateSection from "@/components/CorporateSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import MobileStickyCTA from "@/components/MobileStickyCTA";

function setMeta(selector, attribute, value) {
  const node = document.querySelector(selector);
  if (node) {
    node.setAttribute(attribute, value);
  }
}

export default function LandingPage() {
  useEffect(() => {
    document.title = "BlackRide | Private Chauffeur Service in Jeddah, Saudi Arabia";
    setMeta('meta[name="description"]', "content", "BlackRide provides premium private chauffeur service in Jeddah for airport transfers, corporate travel, Umrah transport, VIP rides, and intercity journeys across Saudi Arabia.");
    setMeta('meta[name="keywords"]', "content", "private chauffeur Jeddah, premium chauffeur service Jeddah, airport transfer Jeddah, luxury chauffeur Saudi Arabia, corporate chauffeur Jeddah, Makkah transfer, Madinah transfer");
    setMeta('meta[property="og:title"]', "content", "BlackRide | Private Chauffeur Service in Jeddah, Saudi Arabia");
    setMeta('meta[property="og:description"]', "content", "Premium private chauffeur service in Jeddah for airport transfers, executive travel, VIP rides, Umrah journeys, and intercity transfers across Saudi Arabia.");
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", "https://getblackride.com");
    setMeta('meta[name="twitter:title"]', "content", "BlackRide | Private Chauffeur Service in Jeddah, Saudi Arabia");
    setMeta('meta[name="twitter:description"]', "content", "Premium private chauffeur service in Jeddah for airport transfers, executive travel, VIP rides, Umrah journeys, and intercity transfers across Saudi Arabia.");
    setMeta('link[rel="canonical"]', "href", "https://getblackride.com");

    const oldSchema = document.getElementById("homepage-business-schema");
    if (oldSchema) oldSchema.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "homepage-business-schema";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: "BlackRide",
          url: "https://getblackride.com",
          telephone: "+966540423401",
          email: "hello@getblackride.com",
          description: "BlackRide is a premium private chauffeur service in Jeddah serving airport transfers, business travel, luxury rides, Umrah transport, and intercity journeys across Saudi Arabia.",
        },
        {
          "@type": "LocalBusiness",
          name: "BlackRide",
          url: "https://getblackride.com",
          telephone: "+966540423401",
          email: "hello@getblackride.com",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Jeddah",
            addressCountry: "SA",
          },
          areaServed: ["Jeddah", "Makkah", "Madinah", "Saudi Arabia"],
          priceRange: "SAR",
          openingHours: "Mo-Su 00:00-23:59",
        },
        {
          "@type": "Service",
          serviceType: "Private Chauffeur Service",
          provider: {
            "@type": "Organization",
            name: "BlackRide",
            url: "https://getblackride.com",
          },
          areaServed: ["Jeddah", "Makkah", "Madinah", "Saudi Arabia"],
          availableChannel: {
            "@type": "ServiceChannel",
            serviceUrl: "https://getblackride.com",
            availableLanguage: ["English", "Arabic"],
          },
          description: "Private chauffeur service for airport transfers, executive transport, hotel pickups, Umrah travel, and intercity transfers in Saudi Arabia.",
        },
      ],
    });
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <main className="pb-28 md:pb-0">
      <Hero />
      <QuickBookingSection />
      <Trust />
      <VehicleClasses />
      <PricingSection />
      <Services />
      <Testimonials />
      <CoverageSection />
      <CorporateSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
}
